module.exports = __webpack_public_path__ + "img/sggl.05199398.png";